/**
 * The canvas behind everything: near-black, a magenta light-leak, film grain.
 *
 * `fixed inset-0` rather than a background on whatever is scrolling: the glow
 * stays put while content moves over it, which is what makes it read as a
 * light in the room instead of a very large image.
 *
 * `z-0`, not `-z-10`. This sits inside an element that paints its own dark
 * background, and a negative index would put it behind that — leaving a flat
 * black canvas and no sign anything was ever drawn.
 *
 * The grain filter needs its own id per mounted copy. Two `<filter id="x">`
 * in one document is not an error anywhere, it just silently resolves every
 * reference to the first one, and the second aurora comes out clean.
 */
export function Aurora({ id = 'app-bg-grain' }: { id?: string }) {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      <div className="absolute left-1/2 top-1/3 h-[40vh] w-[60vw] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#fc2265] opacity-50 blur-[120px]" />
      <div className="absolute left-1/3 top-2/3 h-[30vh] w-[50vw] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#fc2265] opacity-30 blur-[100px]" />
      <svg className="absolute inset-0 h-full w-full opacity-[0.05] mix-blend-overlay">
        <filter id={id}>
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.85"
            numOctaves={2}
            stitchTiles="stitch"
          />
        </filter>
        <rect width="100%" height="100%" filter={`url(#${id})`} />
      </svg>
    </div>
  );
}
